import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiToggleComponent } from './ui-toggle/ui-toggle.component';
import { UiToolbarButtonComponent } from './ui-toolbar-button/ui-toolbar-button.component';

// Presentational atoms shared across admin and the product screens; feature composites stay in their feature folder.
@NgModule({
  imports: [CommonModule],
  declarations: [
    UiToggleComponent,
    UiToolbarButtonComponent,
  ],
  exports: [
    UiToggleComponent,
    UiToolbarButtonComponent,
  ],
})
export class SharedUiModule {}
